import { head, pathOr, pipe, tail } from 'ramda';
import { camelize } from 'humps';

export const basicSpiderParser = (chartData) => {
  const fields = pathOr([], ['fields'])(chartData);
  const series = tail(fields).map(camelize).reverse();
  const axis = pipe(head, camelize)(fields);
  const labels = {};

  series.forEach((serie, index) => {
    labels[serie] = fields[index + 1];
  });

  chartData.series = series;
  chartData.axis = axis;
  chartData.labels = labels;
};
